<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="box">
            <div class="columns">
                <div class="column is-2">
                    <b-field>
                        <b-input :placeholder="$t('SISTEMA.CODIGO')"
                                v-model="codigoArquiteto"
                                type="number"
                                icon="magnify"
                                @input="loadAsyncData()">
                        </b-input>
                    </b-field>
                </div>
    
                <div class="column is-5">
                    <b-field>
                        <b-input :placeholder="$t('ARQUITETOLISTA.NOMEDOARQUITETO')"
                                 v-model="procurar"
                                 icon="magnify"
                                 @input="loadAsyncData"></b-input>
                    </b-field>
                </div>
    
                <div v-if="!isVendedor()" class="column is-3">
                    <b-field>
                        <b-select  v-model="vendedorFiltro" :placeholder="$t('SISTEMA.VENDEDOR')" @input="loadAsyncData()" expanded>
                            <option :value="null"></option>
                            <template v-for="(item, index) in this.listaVendedoresUnidade">
                                <option v-if="vendedorFiltro == item.id" selected v-bind:key="index" :value="item.id">
                                    {{item.nome}}
                                </option>
                                <option v-else v-bind:key="index" :value="item.id">
                                    {{item.nome}}
                                </option>
                            </template>
                        </b-select>              
                    </b-field>
                </div>
            </div>

            <div class="columns">
                <div class="column buttons is-flex is-justify-content-flex-end">
                    <router-link v-if="isInRole('arquiteto-alterar')" :to="{ name: 'arquiteto' }" class="button is-primary">
                        {{$t('SISTEMA.INCLUIR')}}
                    </router-link>

                    <b-button icon-left="calendar" class="ml-1" :title="$t('ARQUITETOLISTA.ATUALIZARAGENDAS')"
                    @click.prevent.stop="atualizarAgendas()">{{$t('ARQUITETOLISTA.ATUALIZARAGENDAS')}}</b-button>
                </div>
            </div>
        </div>
        <b-table :data="model.lista"
                 :loading="loading"
                 :paginated="false"
                 striped
                 hoverable
                 backend-pagination
                 :total="total"
                 @page-change="onPageChange"
                 :aria-next-label="$t('SISTEMA.PROXPAGINA')"
                 :aria-previous-label="$t('SISTEMA.PAGANTERIOR')"
                 :aria-page-label="$t('SISTEMA.PAGINA')"
                 :aria-current-label="$t('SISTEMA.PAGATUAL')"
                 backend-sorting
                 :default-sort-direction="defaultOrdenar"
                 :default-sort="[ordenarPor, ordenar]"
                 sort-icon-size="is-small"
                 @sort="onSort">

            <template  @click="abrirCadastro(props.row.id)">
                <b-table-column v-slot="props" field="id" :label="$t('SISTEMA.CODIGO')" >
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column v-slot="props" field="Nome" :label="$t('SISTEMA.NOME')" >
                    {{ props.row.nome }}
                    <p v-if="props.row.funcionarioComercial?.nome" class="is-size-7">
                        <b>VENDEDOR:</b> {{ props.row.funcionarioComercial?.nome?.toUpperCase() }}
                    </p>
                </b-table-column>

                <b-table-column v-slot="props" field="Telefone" :label="$t('ARQUITETOLISTA.TELEFONE')" >
                    {{ props.row.telefone }}
                </b-table-column>

                <b-table-column v-slot="props" field="DataNascimento" :label="$t('ARQUITETOLISTA.DATADENASCIMENTO')" >
                    {{ props.row.dataNascimento ? $moment(props.row.dataNascimento).format('DD/MM/YYYY') : null }}
                </b-table-column>

                <b-table-column v-slot="props" field="Nome" :label="$t('ARQUITETOLISTA.INSTAGRAM')" >
                    {{ props.row.instagram }}
                </b-table-column>

                <b-table-column v-slot="props" field="Tipo" :label="$t('SISTEMA.TIPO')" >
                    {{ props.row.tipo }}
                </b-table-column>          
                <b-table-column v-slot="props" field="ProximoContato" :label="$t('ARQUITETOLISTA.PROXIMOCONTATO')" >
                    <span v-if="props.row.dataHoraProximoContato !=null">
                        {{ $moment(props.row.dataHoraProximoContato).format("DD/MM/YYYY HH:mm")  }}
                    </span>
                </b-table-column>                          
                

                <b-table-column v-slot="props" custom-key="actions" numeric>
                    <div class="is-flex is-justify-content-space-evenly">
                        <b-button  class="is-small"  @click="confirmarInclusaoObservacao( props.row.id)" 
                        :title="$t('GUIAATENDIMENTO.INCLUIROBSERVACAO')" icon-left="comment"></b-button>                                                                                                                                                                  
                        <b-button type="is-info" size="is-small" @click="exibirHistorico(props.row.id)" icon-left="clock" :title="$t('ARQUITETOLISTA.HISTORICODEOBSERVACOES')"></b-button>
                        <router-link :to="{ name: 'arquiteto', params: { id: props.row.id }}" class="button is-small is-primary" :title="$t('SISTEMA.EDITAR')">
                            <b-icon icon="pencil" size="is-small"></b-icon>
                        </router-link>
                    </div>
                </b-table-column>
            </template>
        </b-table>
    </section>
</template>

<script>
    import { mapGetters,mapState } from 'vuex'    
    import titlebar from '@/components/titlebar.vue'
    import modalHistoricoObservacoesArquiteto from '../../components/manutencao/modalHistoricoObservacoesArquiteto.vue'
    import modalObservacaoArquiteto  from '@/components/manutencao/modalObservacaoArquiteto.vue'

    export default {
        data() {
            return {
                model: [],
                total: 0,
                loading: false,
                procurar: this.$route.query.procurar ?? "",
                vendedorFiltro: null,
                listaVendedoresUnidade: [],
                codigoArquiteto: null,
                ordenarPor: 'Nome',
                ordenar: 'asc',
                defaultOrdenar: 'asc',
                page: 1,
                perPage: 20,
                selecionado: null,
                id: null
            }
        },
        components: {
            titlebar
        },
        computed: {
            ...mapState([                                
                'unidadeId',  
                'usuario'              
            ]),            
            titleStack() {
                return [
                    this.$t('SISTEMA.MANUTENCAO'),
                    this.$t('ARQUITETOLISTA.ARQUITETOS'),
                ]
            },
            ...mapGetters([
                'isInRole'
            ])
        },
        watch: {            
            unidadeId: function(novaUnidade) {                 
                this.loadAsyncData()                                                
            },
        },        
        methods: {
            confirmarInclusaoObservacao(id) {
                this.$buefy.modal.open({
                    parent: this,
                    component: modalObservacaoArquiteto,
                    props: {
                        id: id                                           
                    },
                    events: {
                        loadData: this.loadAsyncData
                    },                    
                    hasModalCard: true,
                    trapFocus: true
                })
            },                  
            isVendedor(){                
                return this.usuario.nivel == 'Vendedor' || this.usuario.nivel.includes('Vendedor');
            },                  
           loadAsyncData() {

                if(this.isVendedor() )
                    this.vendedorFiltro = this.usuario.funcionarioId;

                const params = [
                    `procurar=${this.procurar}`,
                    `comercialId=${this.vendedorFiltro || ''}`,
                    `codigoArquiteto=${this.codigoArquiteto || ''}`,
                    `ordem=${this.ordenarPor}.${this.ordenar}`,
                    `page=${this.page}`,
                    `unidadeId=${this.unidadeId}`,
                    `perPage=${this.perPage}`
                ].join('&')

                this.loading = true
                this.$http.get(`/api/manutencao/arquitetos?${params}`)
                    .then(({ data }) => {
                        this.model = data;
                        this.total = this.perPage * data.pageCount
                        this.loading = false
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.ordenarPor = field
                this.ordenar = order
                this.loadAsyncData()
            },
            abrirCadastro() {                
                this.$router.push({ name: 'arquiteto', params: {id: this.selecionado.id} })                                            
            },
            atualizarAgendas() {
                const params = [
                    `unidadeId=${this.unidadeId}`
                ].join('&')

                this.loading = true
                this.$http.post(`/api/manutencao/AtualizarAgendasArquitetos?${params}`)
                    .then(res => {
                        if(res.ok){
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: this.$t("ARQUITETOLISTA.AGENDASATUALIZADA"),
                                type: 'is-success',
                                queue: false
                            });
                        }
                    })
                    .catch((error) => {
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: this.$t("ARQUITETOLISTA.ERROAOATUALIZARAGENDAS"),
                            type: 'is-danger',
                            queue: false
                        });

                        throw error
                    }).finally(() => {
                        this.loading = false
                    })
            },
            carregarVendedoresUnidade(){
                this.$http.get(`/api/search/FuncionarioComercial?unidadeId=${this.unidadeId}`)
                .then(res => res.data)
                .then(data => {
                    if (data != null) {
                        this.listaVendedoresUnidade = data;
                    }
                });
            },
            exibirHistorico(arquitetoId) {
                this.$buefy.modal.open({
                    parent: this,
                    component: modalHistoricoObservacoesArquiteto,
                    props: {
                        arquitetoId,
                    },
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen: false
                })
            },

        },
        mounted() {
            this.carregarVendedoresUnidade()
            this.loadAsyncData()
        }
    }
</script>